// Stub for @sentry-internal/feedback when imported statically from @sentry/browser.
// We don't use the Feedback widget; this drops ~20 KB gzip from the main bundle.
export function buildFeedbackIntegration() {
  return () => ({ name: 'Feedback' });
}
export function feedbackModalIntegration() {
  return { name: 'FeedbackModal' };
}
export function feedbackScreenshotIntegration() {
  return { name: 'FeedbackScreenshot' };
}
export function getFeedback() {
  return undefined;
}
export function sendFeedback() {
  return Promise.resolve('');
}
